module.exports = __webpack_public_path__ + "img/bg.af99b561.jpg";